﻿
<template>
  <sui-accordion exclusive styled>

    <sui-accordion-title>
      <sui-icon name="dropdown" />
      {{ $t('cat3aLabel') }}
    </sui-accordion-title>
    <sui-accordion-content>
      <p v-html="$t('cat3aContent')" />
    </sui-accordion-content>

    <sui-accordion-title>
      <sui-icon name="dropdown" />
      {{ $t('cat3bLabel') }}
    </sui-accordion-title>
    <sui-accordion-content>
      <p v-html="$t('cat3bContent')" />
    </sui-accordion-content>

    <sui-accordion-title>
      <sui-icon name="dropdown" />
      {{ $t('cat3cLabel') }}
    </sui-accordion-title>
    <sui-accordion-content>
      <p v-html="$t('cat3cContent')" />
    </sui-accordion-content>

    <sui-accordion-title>
      <sui-icon name="dropdown" />
      {{ $t('cat3dLabel') }}
    </sui-accordion-title>
    <sui-accordion-content>
      <p v-html="$t('cat3dContent')" />
    </sui-accordion-content>

    <sui-accordion-title>
      <sui-icon name="dropdown" />
      {{ $t('cat3eLabel') }}
    </sui-accordion-title>
    <sui-accordion-content>
      <p v-html="$t('cat3eContent')" />
    </sui-accordion-content>

    <sui-accordion-title>
      <sui-icon name="dropdown" />
      {{ $t('cat3fLabel') }}
    </sui-accordion-title>
    <sui-accordion-content>
      <p v-html="$t('cat3fContent')" />
    </sui-accordion-content>

    <sui-accordion-title>
      <sui-icon name="dropdown" />
      {{ $t('cat3gLabel') }}
    </sui-accordion-title>
    <sui-accordion-content>
      <p v-html="$t('cat3gContent')" />
    </sui-accordion-content>

    <sui-accordion-title>
      <sui-icon name="dropdown" />
      {{ $t('cat3hLabel') }}
    </sui-accordion-title>
    <sui-accordion-content>
      <p v-html="$t('cat3hContent')" />
    </sui-accordion-content>

    <sui-accordion-title>
      <sui-icon name="dropdown" />
      {{ $t('cat3iLabel') }}
    </sui-accordion-title>
    <sui-accordion-content>
      <p v-html="$t('cat3iContent')" />
    </sui-accordion-content>

  </sui-accordion>
</template>

<script>
  export default {}
</script>
